module.exports = __webpack_public_path__ + "img/dashboard.963075e9.svg";